import { GRID_DAYS_MAX_RECURRING } from './constants'

/** Max study day included in timeline projection (study duration when set, else grid recurring cap). */
export const resolveProjectionDayCap = studyEndDay => {
  if (studyEndDay != null && studyEndDay >= 1) return Math.floor(Number(studyEndDay))
  return GRID_DAYS_MAX_RECURRING
}
